import React from 'react';
import { Apollo } from './apollo';
import { Provider as RouterProvider } from './router';

const Provider = ({ children }) => {
  return (
    <Apollo>
        <RouterProvider>
          {children}
        </RouterProvider>
    </Apollo>
  )
}

export default Provider;
